module.exports = __webpack_public_path__ + "static/cf-med-ext-d06a325cae76dd466452a38f77704f5b.eot";